// eslint-disable-next-line lodash/import-scope
import get from 'lodash/get';
import { boolCheckboxSpec, group } from '../../lib/editing-configs';
import UniversalAuthButton from '../universal-auth-button/universal-auth-button';
import UniversalButton from '../universal-button/universal-button';
import universalContainer from '../universal-container/universal-container';
import UniversalText from '../universal-text/universal-text';
import BackgroundColor from '../background-color/background-color';

export default (componentDocument) => {
  const authButtonConfig = componentDocument?.props?.includeSignUpButtons
    ? [...UniversalAuthButton.getEditingConfig(componentDocument, 'authButton')]
    : [];

  return [
    boolCheckboxSpec('disableDefaultProps', 'Disable Default Properties?'),
    ...universalContainer.getEditingConfig(
      componentDocument,
      'Container',
      ['backgroundColor', 'backgroundImage', 'border', 'margin', 'padding'],
      'container'
    ),
    ...UniversalText.getEditingConfig(
      componentDocument,
      'Title',
      [
        'textSize',
        'textType',
        'fontWeight',
        'padding',
        'margin',
        'groupButton',
        'textChronicle',
        'textColor',
      ],
      'title'
    ),
    ...UniversalText.getEditingConfig(
      componentDocument,
      'Subtitle',
      [
        'textSize',
        'textType',
        'fontWeight',
        'padding',
        'margin',
        'groupButton',
        'textChronicle',
        'textColor',
      ],
      'subtitle'
    ),
    ...UniversalButton.getEditingConfig(
      componentDocument,
      'Button',
      ['displayStyle', 'disabled', 'ctaSubText', 'loadingMessage', 'alignment'],
      'actionButton'
    ),
    group('Options', [
      boolCheckboxSpec('includeSignUpButtons', 'Add Sign Up buttons?'),
      ...authButtonConfig,
      boolCheckboxSpec(
        'includeContentWidthLimitation',
        'Output Header and Body 2/3 width?'
      ),
      boolCheckboxSpec(
        'includeParentWithLimitation',
        'Limit width of container to centered-in-parent?'
      ),
      ...(get(componentDocument, 'props.includeParentWithLimitation', false)
        ? BackgroundColor.getEditingConfig(
            componentDocument,
            'rootBgOptions',
            'Root background color'
          )
        : []),
    ]),
  ];
};
